import { defineMessages } from 'react-intl'

const scope = `procurify.components.StatementPeriodSelect`

export default defineMessages({
  selectFieldPlaceholder: {
    id: `${scope}.selectFieldPlaceholder`,
    defaultMessage: 'Select a month',
  },
  noOptionsMessage: {
    id: `${scope}.noOptionsMessage`,
    defaultMessage: 'No statements available',
  },
})
